module.exports = __webpack_public_path__ + "img/item12.f840d0bf.png";